import React from 'react';
import PropTypes from 'prop-types';

import { Dialog as MUIDialog } from '@material-ui/core';

export const Dialog = props => <MUIDialog {...props} />;

Dialog.propTypes = {
  PaperProps: PropTypes.object,
  TransitionComponent: PropTypes.elementType,
  TransitionProps: PropTypes.object,
  classes: PropTypes.object,
  disableBackdropClick: PropTypes.bool,
  disableEscapeKeyDown: PropTypes.bool,
  fullScreen: PropTypes.bool,
  fullWidth: PropTypes.bool,
  maxWidth: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl', false]),
  onClose: PropTypes.func,
  open: PropTypes.bool.isRequired,
  scroll: PropTypes.oneOf(['body', 'paper'])
};

export default Dialog;
